import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Hidden, CircularProgress, Button, Checkbox, TableContainer, Table, TableRow, TableHead, TableBody, TableCell, Pagination } from '@material-ui/core'
import { styled } from '@material-ui/core/styles';
import {csvFormat} from 'd3-dsv'

import Moment from 'moment'
import 'moment/locale/fr';

import APIS from "../../../utils/APIS"

import SelectEcoleMenuMobile from "./SelectEcoleMenuMobile"
import MyPopover from "../MyPopover"

import UserAdminClientContext from "../../../contexts/UserAdminClientContext"
import LanguageContext from "../../../contexts/LanguageContext"

import simpleArrowIcon from "../../../images/simpleArrowIcon.svg"
import etudiantsTotIcon from "../../../images/etudiantsTotIcon.svg"
import modulesIcon from "../../../images/modulesIcon.svg"
import tauxCompletionIcon from "../../../images/tauxCompletionIcon.svg"
import moyenneIcon from "../../../images/moyenneIcon.svg"
import softSkillsIcon from "../../../images/softSkillsIcon.svg"
import moyenneTempsIcon from "../../../images/moyenneTempsIcon.svg"
import cadrillageBGCard from "../../../images/cadrillageBGCard.svg"
import filterIcon from "../../../images/filterIcon.svg"
import exportIcon from "../../../images/exportIcon.svg"
import searchIcon from "../../../images/searchIcon.svg"
import checkGreenRoundIcon from "../../../images/checkGreenRoundIcon.svg"
import sablierIcon from "../../../images/sablierIcon.svg"
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { ReactComponent as XIcon } from '../../../images/x-icon.svg'

Moment.locale('fr')

export const Header = ({ title, dataLoaded, withTuto, onClickTuto }) => {
  const {
    ecoles,
    actEcole,
    actEcoleID,
    updateActEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  return (
    <Box sx={{ marginBottom:["30px", "35px", "35px", "45px"] }}>
      <Box sx={{color:"text.blackTitle", marginBottom:"15px", fontSize:["14px", "14px", "15px", "16px"], textTransform:"capitalize"}}>
        {actEcole?.name}
      </Box>
      <Box sx={{display:"flex", gap:"10px", alignItems:"center", justifyContent:"space-between",}}>
        <Box sx={{display:"flex", gap:"8px", alignItems:"center"}}>
          <Box
            sx={{
              width:["25px", "30px", "30px", "35px"],
              minWidth:["25px", "30px", "30px", "35px"],
              cursor:"pointer",
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
            }}
            onClick={() => {
              updateActEcole(actEcoleID, "home")
            }}
          >
            <img src={simpleArrowIcon} style={{width:"100%", transform:"rotate(180deg)"}}/>
          </Box>
          <Box sx={{marginLeft:"10px", fontSize:["26px", "36px", "36px", "42px"], color:"text.black"}}>
            {title}
          </Box>
        </Box>
        {withTuto &&
          <Box>
            <Hidden smDown>
              <Button
                onClick={onClickTuto ? onClickTuto : null}
                size="large"
                type="submit"
                variant="contained"
                sx={{
                  height:["45px !important", "45px !important", "45px !important", "50px !important"],
                  minHeight:["45px !important", "45px !important", "45px !important", "50px !important"],
                  fontSize:["14px", "14px", "15px", "16px"],
                  whiteSpace:"nowrap"
                }}
              >
                {languageValues?.adminDashboard?.seeTuto[actLanguage]}
              </Button>
            </Hidden>
            <Hidden smUp>
              <Button
                disableRipple
                onClick={onClickTuto ? onClickTuto : null}
                sx={{
                  fontSize:"14px",
                  color:"text.black",
                  textDecoration:"underline",
                  textUnderlineOffset: "4px",
                  minWidth:0,
                  "&:hover" : {
                    background:"transparent",
                    color:"text.subTitle",
                    textDecoration:"underline",
                  }
                }}
                size="small"
              >
                {languageValues?.adminDashboard?.seeTuto[actLanguage]}
              </Button>
            </Hidden>
          </Box>
        }
      </Box>
    </Box>
  )
}

export const CardContainer = ({icon, title, value, dataLoaded, unit, forMapping}) => {
  return (
    <Box
      sx={{
        width:
          forMapping === true ? "calc((100% / 2) - (((2 - 1) / 2) * 20px))"
          : [
            "calc((100% / 2) - (((2 - 1) / 2) * 15px))",
            "calc((100% / 3) - (((3 - 1) / 3) * 15px))",
            "calc((100% / 3) - (((3 - 1) / 3) * 15px))",
            "calc((100% / 6) - (((6 - 1) / 6) * 20px))",
          ],
        height: forMapping === true ? ["102px", "145px", "145px", "147px"] : ["102px", "130px", "130px", "130px"],
        minHeight: forMapping === true ? ["102px", "145px", "145px", "147px"] : ["102px", "130px", "130px", "130px"],
        border:"1px solid #E7E7E7",
        backgroundImage:`url(${cadrillageBGCard})`,
        backgroundRepeat:"no-repeat",
        backgroundPosition:"right 5px bottom 5px",
        backgroundColor:"white",
      }}
    >
      <Box sx={{
        width:"100%",
        height:"100%",
        background: "linear-gradient(130deg,rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 95%, rgba(0, 0, 0, 0) 100%)",
      }}>
        {dataLoaded ? (
          <Box sx={{padding:["10px", "15px", "15px", "15px"], display: "flex", flexDirection:"column"}}>
            <Box sx={{display:"flex", gap:"10px", alignItems:"center", marginBottom:["7px", "12px", "12px", "8px"]}}>
              <Box
                sx={{
                  width:["25px", "30px", "30px", "35px"],
                  minWidth:["25px", "30px", "30px", "35px"],
                }}
              >
                <img src={icon} style={{width:"100%"}}/>
              </Box>
              <Box sx={{fontSize:["14px", "15px", "16px", "16px"], color:"text.subTitle", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden",}}>
                {title}
              </Box>
            </Box>
            <Box sx={{fontSize:["30px", "41px", "41px", "46px"], color:"black", display:"flex", alignItems:"flex-end", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden",}}>
              {value}
              {unit &&
                <Box sx={{fontSize:["26px", "22px", "22px", "16px"], color:"text.subTitle", paddingBottom:["3px","5px","5px","5px"], whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden"}}>{unit}</Box>
              }
            </Box>
          </Box>
        ) : (
          <Box sx={{height:"100%", display:"flex", alignItems:"center", justifyContent:"center"}}>
            <CircularProgress size="30px" sx={{'color': 'black'}} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export const FiltersDisplay = ( { filters, setFilters, contents, defaultF, isMapping }) => {
  const {
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [listFilters, setListFilters] = useState([])

  useEffect(() => {
    let arr = []
    for (const [key, value] of Object.entries(filters)) {
      if (value && value.length && value.length > 0) {
        if (key === "moduleIDs" && contents) {
          value.forEach((val) => {
            let name = contents.find((el) => el.id === val).name
            arr.push({type: key, display: name, value : val})
          })
        } else if (key === "groupes" && actEcole?.groupes) {
          value.forEach((val) => {
            let name = actEcole?.groupes?.find((el) => el.groupeID === val).name
            let diplomeName = actEcole?.groupes?.find((el) => el.groupeID === val).diplome
            let textDisplay = ""
            if (diplomeName) {
              textDisplay = diplomeName
            } else {
              textDisplay = name
            }
            arr.push({type: key, display: textDisplay, value : val})
          })
        } else if (key === "campus" && actEcole?.campus) {
          value.forEach((val) => {
            let name = actEcole?.campus?.find((el) => el.id === val).name
            arr.push({type: key, display: name, value : val})
          })
        } else if (key === "moduleTypes") {
          value.forEach((val) => {
            let display = val
            if (val === "identif") {
              display = languageValues?.adminDashboard?.contentType?.identif[actLanguage]
            } else if (val === "enrich") {
              display = languageValues?.adminDashboard?.contentType?.contentType.enrich[actLanguage]
            } else if (val === "icebreaker") {
              display = languageValues?.adminDashboard?.contentType?.contentType.icebreaker[actLanguage]
            }
            arr.push({type: key, display: display, value : val})
          })
        } else if (key === "status") {
          value.forEach((val) => {
            let display = val
            if (val === "notStarted") {
              display = languageValues?.adminDashboard?.statusTypes?.notStarted[actLanguage]
            } else if (val === "inProgress") {
              display = languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]
            } else if (val === "ended") {
              display = languageValues?.adminDashboard?.statusTypes?.ended[actLanguage]
            } else if (val === "endedInRat") {
              display = languageValues?.adminDashboard?.statusTypes?.endedInRat[actLanguage]
            }
            arr.push({type: key, display: display, value : val})
          })
        } else if (key === "level") {
          value.forEach((val) => {
            let display = val
            if (val === "notAcquired") {
              display = languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]
            } else if (val === "inProgress") {
              display = languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]
            } else if (val === "acquired") {
              display = languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]
            } else if (val === "rattrapage") {
              display = languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]
            }
            arr.push({type: key, display: display, value : val})
          })
        } else {
          value.forEach((val) => {
            arr.push({type: key, display: val, value : val})
          })
        }
      }
    }

    setListFilters(arr)
  }, [filters])
  return (
    <Box sx={{display:"flex", gap:"15px", flexWrap:"wrap", marginTop:"7px"}}>
      {listFilters.map((elem, index) => {
        let canDelete = true
        if (isMapping === true) {
          if (elem.type === "groupes") {
            canDelete = false
          }
        }

        return (
          <Box
            key={index}
            sx={{
              display:"flex",
              alignItems:"center",
              gap:"5px",
              cursor:canDelete&&"pointer",
              userSelect:"none",
              color:canDelete===false ? "text.black" : "text.subTitle",
              "&:hover" : {
                color:"text.black",
              }
            }}
            onClick={(e) => {
              if (canDelete === true) {
                setFilters({...filters,
                  [elem.type] : filters[elem.type].filter(a =>
                    a !== elem.value
                  )
                });
              }
            }}
          >
            <Box sx={{
              height:"25px",
              fontSize:"13px",
              background:"white",
              borderRadius:"0px",
              border:"1px dashed #E7E7E7",
              padding:"5px 8px",
              display:"flex",
              alignItems:"center"
            }}>
              {elem.display}
            </Box>
            {canDelete === true &&
              <Box>
                <XIcon />
              </Box>
            }
          </Box>
        )
      })}
      {listFilters.length > 0 &&
        <Box
          sx={{
            cursor:"pointer",
            display:isMapping === true ? listFilters?.some((el) => el.type !== "groupes") ? "flex" : "none" : "flex",
            alignItems:"center",
            fontSize:"12px",
            color:"text.subTitle",
            textDecoration:"underline",
            textUnderlineOffset: "3px",
            userSelect:"none",
            '&:hover': {
              color:"text.black"
            },
          }}
          onClick={(e) => {
            if (isMapping === true) {
              let newFilters = JSON.parse(JSON.stringify(defaultF))
              newFilters.groupes = filters.groupes
              setFilters(newFilters)
            } else {
              setFilters(defaultF)
            }
          }}
        >
          {languageValues?.adminDashboard?.filters?.deleteAll[actLanguage]}
        </Box>
      }
    </Box>
  )
}

const ActionList = ({ glbData, filters, setFilters, icebreakerQuestions }) => {
  const {
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [actItem, setActItem] = useState(null)
  const menuOpenClose = (item) => {
    if (item === actItem) {
      setActItem(null)
    } else {
      setActItem(item)
    }
  }

  return (
    <Box sx={{display:"flex", alignItems:"flex-start"}}>
      <Box sx={{
        minWidth:"220px",
        maxWidth:"350px",
        padding:"10px 20px",
        boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
        border: "1px solid black",
        background:"white",
      }}>
        {actEcole?.groupes?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.groupe[actLanguage]}
              onClick={() => {menuOpenClose("groupe")}} selected={actItem === "groupe"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "groupe" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                  datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.secteurs === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.sector[actLanguage]}
              onClick={() => {menuOpenClose("secteur")}} selected={actItem === "secteur"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "secteur" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.sectorSub[actLanguage]}
                  datas={icebreakerQuestions.secteursReps} filterType="secteur" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {actEcole?.campus?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.campus[actLanguage]}
              onClick={() => {menuOpenClose("campus")}} selected={actItem === "campus"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "campus" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                  datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.diplome === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.graduationYear[actLanguage]}
              onClick={() => {menuOpenClose("diplome")}} selected={actItem === "diplome"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "diplome" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage]}
                  datas={icebreakerQuestions.anneesReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.annees === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.studyYear[actLanguage]}
              onClick={() => {menuOpenClose("etude")}} selected={actItem === "etude"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "etude" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage]}
                  datas={icebreakerQuestions.diplomeReps} filterType="anneesEtude" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        <ItemPopover
          title={languageValues?.adminDashboard?.filters?.moduleType[actLanguage]}
          onClick={() => {menuOpenClose("type")}} selected={actItem === "type"} icon={filterIcon}
        />
        <Hidden mdUp>
          {actItem === "type" &&
            <FilterList
              title={languageValues?.adminDashboard?.filters?.moduleTypeSub[actLanguage]}
              datas={contentsTypes} filterType="moduleTypes" filters={filters} setFilters={setFilters}
            />
          }
        </Hidden>
        <ItemPopover
          title={languageValues?.adminDashboard?.filters?.moduleName[actLanguage]}
          onClick={() => {menuOpenClose("nom")}} selected={actItem === "nom"} icon={filterIcon}
        />
        <Hidden mdUp>
          {actItem === "nom" &&
            <FilterList
              title={languageValues?.adminDashboard?.filters?.moduleNameSub[actLanguage]}
              datas={glbData.contents} dataToDisplay="name" dataToCheck="id" filterType="moduleIDs" filters={filters} setFilters={setFilters}
            />
          }
        </Hidden>
        <ItemPopover
          title={languageValues?.adminDashboard?.filters?.status[actLanguage]}
          onClick={() => {menuOpenClose("status")}} selected={actItem === "status"} icon={filterIcon}
        />
        <Hidden mdUp>
          {actItem === "status" &&
            <FilterList
              title={languageValues?.adminDashboard?.filters?.statusSub[actLanguage]}
              datas={statusTypes} filterType="status" filters={filters} setFilters={setFilters}
            />
          }
        </Hidden>
      </Box>
      <Hidden mdDown>
        {actItem !== null &&
          <Box sx={{
            marginLeft:"10px",
            maxWidth:"350px",
            minWidth:"200px",
            padding:"10px 20px",
            boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
            border: "1px solid black",
            background:"white",
          }}>
            {actItem === "nom" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.moduleNameSub[actLanguage]}
                datas={glbData.contents} dataToDisplay="name" dataToCheck="id" filterType="moduleIDs" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "type" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.moduleTypeSub[actLanguage]}
                datas={contentsTypes} filterType="moduleTypes" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "groupe" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "campus" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "secteur" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.sectorSub[actLanguage]}
                datas={icebreakerQuestions.secteursReps} filterType="secteur" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "etude" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage]}
                datas={icebreakerQuestions.diplomeReps} filterType="anneesEtude" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "diplome" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage]}
                datas={icebreakerQuestions.anneesReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "status" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.statusSub[actLanguage]}
                datas={statusTypes} filterType="status" filters={filters} setFilters={setFilters}
              />
            }
          </Box>
        }
      </Hidden>
    </Box>
  )
}

export const ItemPopover = ({ icon, title, onClick, selected }) => {
  return (
    <Box
      sx={{
        display:"flex",
        alignItems:"center",
        justifyContent:"space-between",
        color:selected ? "text.black" : "text.subTitle",
        fontSize:"14px",
        height:"35px",
        cursor:"pointer",
        '&:hover': {
          color:"text.black"
        },
      }}
      onClick={onClick}
    >
      <Box sx={{display:"flex", alignItems:"center", gap:"10px"}} >
        <Box sx={{width:'17px', height:"100%", display:"flex", alignItems:"center"}}>
          <img src={icon} style={{width:"100%"}} />
        </Box>
        <Box>{title}</Box>
      </Box>
      <Hidden mdUp>
        <KeyboardArrowDownIcon />
      </Hidden>
      <Hidden mdDown>
        <KeyboardArrowDownIcon style={{transform: "rotate(-90deg)"}}/>
      </Hidden>
    </Box>
  )
}

export const FilterList = ({ title, filters, setFilters, datas, filterType, dataToDisplay, dataToCheck, onlyOneSelection }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)

  let datasUniques = []
  if (filterType === "groupes") {
    datasUniques = [...new Set(datas)].sort((a, b) => {
      let textA = ""
      if (a.diplome) { textA = a.diplome } else { textA = a.name }
      let textB = ""
      if (b.diplome) { textB = b.diplome } else { textB = b.name }
      return textA.localeCompare(textB)
    })
  } else if (filterType === "secteur") {
    datas.map((x) => {
      datasUniques.push(x.trim())
    })
    datasUniques = [...new Set(datasUniques)].sort()
  } else if (filterType === "secteur") {
    datas.map((x) => {
      datasUniques.push(x.trim())
    })
    datasUniques = [...new Set(datasUniques)].sort()
  } else if (filterType === "diplome") {
    datas.map((x) => {
      datasUniques.push(x.trim())
    })
    datasUniques = [...new Set(datasUniques)].sort()
  } else if (filterType === "etude") {
    datasUniques = [...new Set(datas)].sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
  } else if (filterType === "moduleIDs") {
    datas.forEach((x) => {
      let find = datasUniques.find((el) => el.id === x.id)
      if (!find) {
        datasUniques.push(x)
      }
    })
    datasUniques = [...new Set(datasUniques)].sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
  } else {
    datasUniques = [...datas]
  }

  return (
    <Box>
      <Hidden mdDown>
        <Box sx={{display:"flex", height:"40px", alignItems:"center", justifyContent:"space-between", gap:"5px"}}>
          <Box sx={{fontSize:"14px", color:"black"}}>
            {title}
          </Box>
          <Box
            sx={{
              cursor:"pointer",
              fontSize:"12px",
              textDecoration :"underline",
              textUnderlineOffset: "3px",
              color: "text.subTitle",
              userSelect:"none",
              '&:hover': {
                color:"text.black"
              },
              display:onlyOneSelection ? "none" : "block",
            }}
            onClick={() => {
              setFilters({...filters,
                [filterType] : []
              });
            }}
          >
            {languageValues?.adminDashboard?.filters?.delete[actLanguage]}
          </Box>
        </Box>
      </Hidden>
      <Box sx={{
        maxHeight:'300px',
        overflowX:"auto",
        scrollbarColor: "#FAF8F6 transparent",
        marginLeft:"10px",
        paddingLeft:"10px",
        marginBottom:["15px", "15px", "10px", "10px"],
        marginTop:["5px", "5px", "0px", "0px"],
        borderLeft:"1px solid rgba(74, 74, 74, 0.2)"
      }}>
        {datasUniques.map((elem, i) => {
          let valueToCheck = null
          if (dataToCheck) {
            valueToCheck = elem[dataToCheck]
          } else {
            valueToCheck = elem
          }
          let checked = filters[filterType].includes(valueToCheck)
          return (
            <Box
              key={i}
              sx={{
                cursor:"pointer",
                padding:"5px 0px",
                display:"flex",
                alignItems:"center",
                gap:"5px",
                color:checked ? "text.black" : "text.subTitle",
                '&:hover': {
                  color:"text.black"
                },
              }}
              onClick={(e) => {
                if (onlyOneSelection === true) {
                  if (checked) {
                    /*setFilters({...filters,
                      [filterType] : []
                    });*/
                  } else {
                    setFilters({...filters,
                      [filterType] : [valueToCheck]
                    });
                  }
                } else {
                  if (checked) {
                    setFilters({...filters,
                      [filterType] : filters[filterType].filter(a =>
                        a !== valueToCheck
                      )
                    });
                  } else {
                    setFilters({...filters,
                      [filterType] : [...filters[filterType], valueToCheck]
                    });
                  }
                }
              }}
            >
              <Checkbox
                checked={checked}
                sx={{
                  padding:0,
                  color:'rgba(206, 206, 206, 0.5)',
                  '&.Mui-checked' : {
                    color:"text.black",
                  }
                }}
                disableRipple
              />
              <Box sx={{
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow:"hidden",
                fontSize:"13px",

              }}>
                {(filterType !== "moduleTypes" && filterType !== "status" && filterType !== "level") ? (
                  <>
                    {getDisplayValueForFilterList(elem, dataToDisplay)}
                  </>
                ) : (
                  <>
                    {elem === 'identif' && languageValues?.adminDashboard?.contentType?.identif[actLanguage]}
                    {elem === 'enrich' && languageValues?.adminDashboard?.contentType?.enrich[actLanguage]}
                    {elem === 'icebreaker' && languageValues?.adminDashboard?.contentType?.icebreaker[actLanguage]}

                    {elem === 'notStarted' && languageValues?.adminDashboard?.statusTypes?.notStarted[actLanguage]}
                    {elem === 'inProgress' && languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]}
                    {elem === 'ended' && languageValues?.adminDashboard?.statusTypes?.ended[actLanguage]}
                    {elem === 'endedInRat' && languageValues?.adminDashboard?.statusTypes?.endedInRat[actLanguage]}

                    {elem === 'notAcquired' && languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]}
                    {elem === 'acquired' && languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]}
                    {elem === 'rattrapage' && languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]}
                  </>
                )}
              </Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

const getDisplayValueForFilterList = (elem, dataToDisplay) => {
  if (dataToDisplay) {
    if (typeof(dataToDisplay) === "string") {
      return elem[dataToDisplay]
    } else if (typeof(dataToDisplay) === "object") {
      for (let i=0; i<dataToDisplay.length; i++) {
        if (elem[dataToDisplay[i]]) {
          return elem[dataToDisplay[i]]
        }
      }
    }
  } else {
    return elem
  }
}


let defautFilters = {
  moduleIDs : [],
  moduleTypes : [],
  groupes : [],
  campus : [],
  anneesEtude : [],
  anneesDiplome : [],
  secteur : [],
  status : [],
}
let contentsTypes = ['icebreaker', 'identif', 'enrich']
let statusTypes = ['notStarted', 'inProgress', 'ended'/* ,'endedInRat'*/]

const Suivi = ({ }) => {

  const {
    ecoles,
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)


  const [dataLoaded, setDataLoaded] = useState(false)
  const [glbData, setGlbData] = useState(null)
  const [filteredData, setFilteredData] = useState([])
  const [filteredStat, setFilteredStat] = useState({})
  const [filters, setFilters] = useState(defautFilters)

  const [nbrPage, setNbrPage] = useState(1)
  const [page, setPage] = useState(1)

  const [popoverFilters, setPopoverFilters] = useState(false)
  const popoverRef = useRef()

  useEffect(() => {
    setDataLoaded(false)
    if (actEcole?.groupes?.length > 0) {
      let fetchData = []
      let icebreakerIDs = []
      if (checkIfHaveRat() === true) {
        statusTypes = ['notStarted', 'inProgress', 'ended' ,'endedInRat']
      } else {
        statusTypes = ['notStarted', 'inProgress', 'ended']
      }
      actEcole?.groupes?.forEach((g) => {
        if (g.icebreaker !== null) {
          let ids = []
          if (g?.icebreaker) {
            ids.push(g?.icebreaker)
            icebreakerIDs.push(g?.icebreaker)
          }
          g?.plan?.plan?.forEach((p) => {
            ids.push(p.id)
          })
          fetchData.push({
            groupeID : g.groupeID,
            ids : ids,
            icebreaker : g.icebreaker
          })
        }
      })
      if (fetchData.length > 0) {
        APIS.clientAdminSuivi({fetchData : fetchData}).then((result) => {
            if (result?.value?.length > 0) {
              let finalData = {
                contents : [],
                results : [],
                users : [],
                nbrUsersTotal : 0
              }
              result?.value?.forEach((d) => {
                if (d.isOk === true && d.contents && d.results) {
                  //on rechercher les résultats pour chaque user
                  d.users.forEach((user) => {
                    d.contents.forEach((content) => {
                      let find = d.results.find((el) => el.contentID === content.id && el.userID === user.id)
                      if (!find) {
                        d.results.push({
                          campusID : user.campusID,
                          groupeID : d.groupeID,
                          contentID : content.id,
                          userID : user.id,
                          name : user.name,
                          icebreakerResults : user.icebreakerResults,
                          isDone : 0,
                          isDoneInRat : 0,
                          progress : 0,
                        })
                      } else {
                        find.groupeID = d.groupeID
                        find.campusID = user.campusID
                      }
                    });
                  })

                  finalData.nbrUsersTotal += d.nbrUsersTotal

                  d.contents.forEach((content) => {
                    content.groupeID = d?.groupeID
                    finalData.contents.push(content)
                  })
                  d.users.forEach((user) => {
                    finalData.users.push(user)
                  })
                  d.results.forEach((result) => {
                    finalData.results.push(result)
                  })
                }
              })

              let finalContentsFiltered = []
              finalData?.contents?.forEach((content) => {
                let find = finalContentsFiltered.find((el) => el.id === content.id)
                if (find) {
                  if (content.groupeID) {
                    find.groupeIDs.push(content.groupeID)
                  }
                } else {
                  let newContent = {...content}
                  newContent.groupeIDs = []
                  if (content.groupeID) { newContent?.groupeIDs?.push(content.groupeID)}
                  delete newContent.groupeID
                  finalContentsFiltered.push(newContent)
                }
              })

              finalData.contents = finalContentsFiltered
              finalData.icebreakerIDs = icebreakerIDs

              setGlbData(finalData)
              setDataLoaded(true)
            } else {
              setDataLoaded(false)
            }
          })
      }
    }
  }, [actEcole])

  useEffect(() => {
    if (glbData !== null) {
      let newArr = []
      if (glbData.contents && glbData.contents.length > 0 && glbData.results && glbData.results.length > 0) {
        glbData.contents.forEach((content) => {
          content.softSkills = content.softSkills?.filter((el) => el.value === 'oui')
        });
        glbData.results.forEach((res) => {
          let scoreGlobale = 0;
          if (res.resultFin?.glbMaster?.score) {
            scoreGlobale = res.resultFin.glbMaster.score
          } else if (res.resultFin?.master?.score) {
            scoreGlobale = res.resultFin.master.score
          }
          let isIcebreakerResult = glbData?.icebreakerIDs?.includes(res?.contentID)
          let obj = {
            userName : res.name,
            userID : res.userID,
            contentID : res.contentID,
            groupeID : res.groupeID,
            campusID : res.campusID,
            contentName : glbData.contents.find((el) => el.id === res.contentID).name,
            contentType : glbData.contents.find((el) => el.id === res.contentID).type,
            /*anneeEtude : res.icebreakerResults?.annees || null,
            anneeDiplome : res.icebreakerResults?.diplome || null,*/
            anneeEtude : res.icebreakerResults?.diplome || null,
            anneeDiplome : res.icebreakerResults?.annees || null,
            secteur : res.icebreakerResults?.secteurs || null,
            scoreGlobale : scoreGlobale,
            updatedAt : res.updatedAt,
            progress : res.progress,
            status : (res.progress == 100 && res.isDone == 1) ? "ended" : res.progress > 0 ? "inProgress" : "notStarted",
            endedInRat : res.isDoneInRat == 1 ? true : false,
            isIcebreakerResult : isIcebreakerResult
          }
          //console.log(obj)
          newArr.push(obj)
        })
      }

      //for TEST
      /*let testArr = []
      for(let i=0; i<48; i++) {
        if (newArr[0]) { testArr.push(newArr[0]) }
        if (newArr[1]) { testArr.push(newArr[1]) }
      }
      newArr = testArr*/

      //filtered
      if (filters.moduleIDs.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.moduleIDs.includes(el.contentID)
        })
      }
      if (filters.moduleTypes.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.moduleTypes.includes(el.contentType)
        })
      }
      if (filters.campus.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.campus.includes(el.campusID)
        })
      }
      if (filters.groupes.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.groupes.includes(el.groupeID)
        })
      }
      if (filters.secteur.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.secteur.includes(el.secteur)
        })
      }
      if (filters.anneesEtude.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.anneesEtude.includes(el.anneeEtude)
        })
      }
      if (filters.anneesDiplome.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.anneesDiplome.includes(el.anneeDiplome)
        })
      }
      if (filters.status.length !== 0) {
        newArr = newArr.filter((el) => {
          for (let i=0; i<filters.status.length; i++) {
            let actStatus = filters.status[i]
            if (actStatus === "notStarted") {
              if (el.status === "notStarted") { return true }
            } else if (actStatus === "inProgress") {
              if (el.status === "inProgress") { return true }
            } else if (actStatus === "ended") {
              if (el.status === "ended" && el.endedInRat !== true) { return true }
            } else if (actStatus === "endedInRat") {
              if (el.status === "ended" && el.endedInRat === true) { return true }
            }
          }
        })
      }

      let additionScore = 0;
      newArr.forEach((res) => {
        if (res.status === "ended" && res.isIcebreakerResult !== true) {
          additionScore+=parseInt(res.scoreGlobale)
        }
      })
      //let softSkills = 0;
      let softSkillsArr = []
      let uniqueSoftSkills = []
      let timing = 0;
      let nbrModules = 0
      let completion = 0;
      if (filters.moduleIDs.length === 0 && filters.moduleTypes.length === 0 && filters.groupes.length === 0) {
        glbData.contents.forEach((content) => {
          nbrModules+= 1
          if (content.softSkills && content.softSkills?.length > 0) {
            content.softSkills.forEach((skill) => {
              softSkillsArr.push(skill)
            })
          }
          timing += content.timing
        })
      } else {
        let contentsCopy = JSON.parse(JSON.stringify(glbData.contents))
        if (filters.moduleIDs.length !== 0) {
          contentsCopy = contentsCopy.filter((el) => {
            return filters.moduleIDs.includes(el.id)
          })
        }
        if (filters.moduleTypes.length !== 0) {
          contentsCopy = contentsCopy.filter((el) => {
            return filters.moduleTypes.includes(el.type)
          })
        }
        if (filters.groupes.length !== 0) {
          contentsCopy = contentsCopy.filter((el) => {
            for (let i=0; i<filters?.groupes?.length; i++) {
              if (el?.groupeIDs?.includes(filters?.groupes[i])) {
                return true
                break
              }
            }
          })
        }
        contentsCopy.forEach((content) => {
          nbrModules+= 1
          if (content.softSkills && content.softSkills?.length > 0) {
            content.softSkills.forEach((skill) => {
              softSkillsArr.push(skill)
            })
          }
          timing += content.timing
        })
      }

      //on trie par ordre alphabétiques
      newArr = newArr.sort((a,b)=>a.userName.localeCompare(b.userName))



      if (newArr.length === 0) {
        completion = "-"
      } else {
        completion = (newArr.filter((el) => el.status === "ended").length / newArr.length ) * 100
        //completion =  Math.round( (completion) *100 )/100+"%"
        //completion = (newArr.length / (glbData.nbrUsersTotal * nbrModules)) * 100
        completion = Math.round(completion)+"%"
      }

      //on enlève les doublons de softskills
      softSkillsArr.forEach((skill) => {
        let find = uniqueSoftSkills.find((el) => el.key === skill.key)
        if (!find) {
          uniqueSoftSkills.push(skill)
        }
      })

      //calcul de la moyenne

      let newStat = {
        etudiantTot : glbData.nbrUsersTotal,
        modules : nbrModules,
        tauxCompletion : completion,
        //moyenne : newArr.length === 0 ? "-" : Math.round( (additionScore/newArr.length) *100 )/100,
        moyenne : newArr.filter((el) => el.status === "ended" && el.isIcebreakerResult !== true).length === 0 ? "-" : Math.round(additionScore/newArr.filter((el) => el.status === "ended" && el.isIcebreakerResult !== true).length),
        softSkills : uniqueSoftSkills?.length,
        timing : timing,
      }


      setNbrPage(Math.ceil(newArr.length/25))
      setPage(1)

      //console.log(newArr)
      setFilteredData(newArr)
      setFilteredStat(newStat)
    }
  }, [glbData, filters])

  const handleExport = () => {
    let filename = 'Export '+languageValues?.adminDashboard?.monitoring[actLanguage]+' ' + actEcole?.name + ', ' + Moment().format('DD/MM/YYYY') + ', ' + Moment().format('HH')+'h'+Moment().format('mm')
    const renameKeys = (keysMap, objs) => {
      for (let i=0; i<objs.length;i++) {
        let obj = objs[i]
        objs[i] = Object.keys(obj).reduce(
        (acc, key) => ({
            ...acc,
            ...{ [keysMap[key] || key]: obj[key] }
        }),
        {})
      }
      return objs
    }

    let fieldsRename = {
      userName : languageValues?.adminDashboard?.monitoringTable?.name[actLanguage],
      certification : languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage],
      secteur : languageValues?.adminDashboard?.monitoringTable?.sector[actLanguage],
      campus : languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage],
      anneeDiplome : languageValues?.adminDashboard?.monitoringTable?.graduationYear[actLanguage],
      anneeEtude : languageValues?.adminDashboard?.monitoringTable?.studyYear[actLanguage],
      contentType : languageValues?.adminDashboard?.monitoringTable?.moduleType[actLanguage],
      contentName : languageValues?.adminDashboard?.monitoringTable?.module[actLanguage],
      status : languageValues?.adminDashboard?.monitoringTable?.score[actLanguage],
      rattrapage : languageValues?.adminDashboard?.monitoringTable?.rattrapageExport[actLanguage],
      progress : languageValues?.adminDashboard?.monitoringTable?.score[actLanguage]+" (%)",
      scoreGlobale : "Score (%)",
    }
    let fieldsExport = [
      languageValues?.adminDashboard?.monitoringTable?.name[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.sector[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.graduationYear[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.studyYear[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.moduleType[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.module[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.score[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.rattrapageExport[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.score[actLanguage]+" (%)",
      "Score (%)",
    ]

    if (actEcole?.campus?.length < 1) {
      delete fieldsRename.campus;
      let index = fieldsExport.indexOf(languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage]);
      if (index > -1) {
        fieldsExport.splice(index, 1);
      }
    }

    if (checkIfHaveRat() === false) {
      delete fieldsRename.rattrapage
      let index = fieldsExport.indexOf(languageValues?.adminDashboard?.monitoringTable?.rattrapageExport[actLanguage]);
      if (index > -1) {
        fieldsExport.splice(index, 1);
      }
    }

    let toAddToExport = JSON.parse(JSON.stringify(filteredData))
    toAddToExport.forEach((res) => {
      if (res.contentType === 'identif') {
        res.contentType = languageValues?.adminDashboard?.contentType?.identif[actLanguage]
      }
      if (res.contentType === 'enrich') {
        res.contentType = languageValues?.adminDashboard?.contentType?.enrich[actLanguage]
      }
      if (res.contentType === 'icebreaker') {
        res.contentType = languageValues?.adminDashboard?.contentType?.icebreaker[actLanguage]
      }

      if (res.status === "notStarted") {
        res.status = languageValues?.adminDashboard?.statusTypes?.notStarted[actLanguage]
      } else if (res.status === "inProgress") {
        res.status = languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]
      } else if (res.status === "ended") {
        res.status = languageValues?.adminDashboard?.statusTypes?.ended[actLanguage]
      }

      if (res.endedInRat === true) {
        res.rattrapage = languageValues?.adminDashboard?.monitoringTable?.oui[actLanguage]
      } else {
        res.rattrapage = languageValues?.adminDashboard?.monitoringTable?.non[actLanguage]
      }

      let findGroup = actEcole?.groupes?.find((el) => el.groupeID === res.groupeID)
      let textGroupe = "-"
      if (findGroup?.diplome) {
        textGroupe = findGroup?.diplome
      } else if (findGroup?.name) {
        textGroupe = findGroup?.name
      }
      res.certification = textGroupe
      let findCampus = actEcole?.campus?.find((el) => el.id === res.campusID)
      let textCampus = "-"
      if (findCampus?.name) {
        textCampus = findCampus?.name
      }
      res.campus = textCampus
    })

    let rename = renameKeys(fieldsRename,  toAddToExport);
    let csv = csvFormat(rename, fieldsExport);
    var link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
    link.setAttribute('download', filename+'.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const checkIfHaveRat = () => {
    let haveRat = false
    for (let i=0; i<actEcole?.groupes?.length; i++) {
      let g = actEcole?.groupes[i]
      //console.log(g)
      for (let i2=0; i2 < g.plan?.plan?.length; i2++) {
        if (g?.plan?.plan[i2]?.enableRat === true) {
          haveRat = true
        }
      }
    }

    return haveRat
  }



  return (
    <>
      <Hidden smUp>
        <SelectEcoleMenuMobile />
      </Hidden>

      <Box
        sx={{
          flex:1,
          padding:["20px", "50px", "50px", "80px"],
          backgroundColor:"background.grey",
        }}
      >
        <Header
          title={languageValues?.adminDashboard?.monitoring[actLanguage]}
          dataLoaded={dataLoaded && glbData !== null && filteredData.length !== 0}
        />

        <Box sx={{display:"flex", flexWrap:"wrap", gap:["15px","15px","15px","20px"]}}>
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.students[actLanguage]}
            value={filteredStat.etudiantTot !== undefined ? filteredStat.etudiantTot : "-"} icon={etudiantsTotIcon} dataLoaded={dataLoaded}
          />
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.modules[actLanguage]}
            value={filteredStat.modules !== undefined ? filteredStat.modules : "-"} icon={modulesIcon} dataLoaded={dataLoaded}
          />
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.completion[actLanguage]}
            value={filteredStat.tauxCompletion !== undefined ? filteredStat.tauxCompletion : "-"} icon={tauxCompletionIcon} dataLoaded={dataLoaded}
          />
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.average[actLanguage]} unit="&nbsp;/100"
            value={filteredStat.moyenne !== undefined ? filteredStat.moyenne : "-"} icon={moyenneIcon} dataLoaded={dataLoaded}
          />
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.softSkills[actLanguage]}
            value={filteredStat.softSkills !== undefined ? filteredStat.softSkills : "-"} icon={softSkillsIcon} dataLoaded={dataLoaded}
          />
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.time[actLanguage]} unit="&nbsp;MIN"
            value={filteredStat.timing !== undefined ? filteredStat.timing : "-"} icon={moyenneTempsIcon} dataLoaded={dataLoaded}
          />
        </Box>


        {dataLoaded && glbData !== null && filteredStat !== {} &&
          <>
            <Box sx={{
              display:"flex",
              gap:"10px",
              justifyContent:"space-between",
            }}>
              <Box sx={{
                marginTop:"35px",
                display:"flex",
                gap:["8px", "8px", "15px", "15px"],
                flexDirection:["column", "column", "row", "row"],
                alignItems:"flex-start",
              }}>
                <Button
                  ref={popoverRef}
                  disabled={!dataLoaded}
                  variant="contained"
                  disableRipple
                  sx={{
                    height:"40px !important",
                    minHeight:"40px !important",
                    flexShrink:0,
                    textTransform:"none",
                    background:"white",
                    color:"text.black",
                    boxShadow:"none",
                    border:"1px solid #E7E7E7",
                    fontSize:"14px !important",
                    gap:"8px",
                    '&:hover': {
                      background:"white",
                      border:"1px solid black",
                    },
                  }}
                  onClick={() => { setPopoverFilters(true) }}
                >
                  <img src={searchIcon} style={{width:"14px"}} />
                  <span>
                    {languageValues?.adminDashboard?.filters?.addFilter[actLanguage]}
                  </span>
                </Button>
                <FiltersDisplay filters={filters} setFilters={setFilters} contents={glbData.contents} defaultF={defautFilters}/>
              </Box>
              <Button
                disabled={!dataLoaded}
                variant="contained"
                disableRipple
                sx={{
                  marginTop:"35px",
                  height:"40px !important",
                  minHeight:"40px !important",
                  flexShrink:0,
                  textTransform:"none",
                  background:"white",
                  color:"text.black",
                  boxShadow:"none",
                  border:"1px solid #E7E7E7",
                  fontSize:"14px !important",
                  gap:"8px",
                  minWidth:"0 !important",
                  '&:hover': {
                    background:"white",
                    border:"1px solid black",
                  },
                }}
                onClick={() => { handleExport() }}
              >
                <img src={exportIcon} style={{width:"15px"}} />
                <Hidden mdDown>
                  <span>
                    {languageValues?.adminDashboard?.exportTable[actLanguage]}
                  </span>
                </Hidden>
              </Button>

            </Box>

            <TableContainer sx={{marginTop:"25px"}}>
              <Table
                sx={{ minWidth: '100%' }}
              >
                <TableHead>
                  <TableRow sx={{
                    background: "#FAF8F6",
                    '& th': {
                      color:"text.subTitle",
                      fontSize:"15px",
                      border:"1px solid #E7E7E7"
                    }
                  }}>
                    <TableCell align="left" sx={{padding:"10px 16px"}}>
                      {languageValues?.adminDashboard?.monitoringTable?.name[actLanguage]}
                    </TableCell>
                    <Hidden mdDown>
                      <TableCell align="left" sx={{padding:"10px 16px"}}>
                        {languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage]}
                      </TableCell>
                      {actEcole?.icebreakerQuestions?.secteurs === true &&
                        <TableCell align="left" sx={{padding:"10px 16px"}}>
                          {languageValues?.adminDashboard?.monitoringTable?.sector[actLanguage]}
                        </TableCell>
                      }
                      {actEcole?.campus?.length > 1 &&
                        <TableCell align="left" sx={{padding:"10px 16px"}}>
                          {languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage]}
                        </TableCell>
                      }
                      {actEcole?.icebreakerQuestions?.diplome === true &&
                        <TableCell align="left" sx={{padding:"10px 16px"}}>
                          {languageValues?.adminDashboard?.monitoringTable?.graduationYear[actLanguage]}
                        </TableCell>
                      }
                      {actEcole?.icebreakerQuestions?.annees === true &&
                        <TableCell align="left" sx={{padding:"10px 16px"}}>
                          {languageValues?.adminDashboard?.monitoringTable?.studyYear[actLanguage]}
                        </TableCell>
                      }
                    </Hidden>
                    <Hidden smDown>
                      <TableCell align="left" sx={{padding:"10px 16px"}}>
                        {languageValues?.adminDashboard?.monitoringTable?.moduleType[actLanguage]}
                      </TableCell>
                    </Hidden>
                    <TableCell align="left" sx={{padding:"10px 16px"}}>
                      {languageValues?.adminDashboard?.monitoringTable?.module[actLanguage]}
                    </TableCell>
                    <TableCell align="left" sx={{padding:"10px 16px"}}>
                      {languageValues?.adminDashboard?.monitoringTable?.score[actLanguage]}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {filteredData.slice(
                  (page-1) * 25,
                  ((page-1) * 25) + 25
                ).map((row, index) => {
                  let findGroup = actEcole?.groupes?.find((el) => el.groupeID === row.groupeID)
                  let textGroupe = "-"
                  if (findGroup?.diplome) {
                    textGroupe = findGroup?.diplome
                  } else if (findGroup?.name) {
                    textGroupe = findGroup?.name
                  }
                  let findCampus = actEcole?.campus?.find((el) => el.id === row.campusID)
                  let textCampus = "-"
                  if (findCampus?.name) {
                    textCampus = findCampus?.name
                  }
                  return (
                    <TableRow
                      key={index}
                      sx={{
                        background : "white",
                        '& td': {
                          border:"1px solid #E7E7E7",
                        }
                      }}
                    >
                      <TableCell sx={{fontSize:"13px", color:"text.black", textTransform:"capitalize"}}>
                        {row.userName}
                      </TableCell>
                      <Hidden mdDown>
                        <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                          {textGroupe}
                        </TableCell>
                        {actEcole?.icebreakerQuestions?.secteurs === true &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                            {row.secteur ? row.secteur : "-"}
                          </TableCell>
                        }
                        {actEcole?.campus?.length > 1 &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                            {textCampus}
                          </TableCell>
                        }
                        {actEcole?.icebreakerQuestions?.diplome === true &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                            {row.anneeDiplome ? row.anneeDiplome : "-"}
                          </TableCell>
                        }
                        {actEcole?.icebreakerQuestions?.annees === true &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                            {row.anneeEtude ? row.anneeEtude : "-"}
                          </TableCell>
                        }
                      </Hidden>
                      <Hidden smDown>
                        <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                          {row.contentType === 'identif' &&
                            languageValues?.adminDashboard?.contentType?.identif[actLanguage]
                          }
                          {row.contentType === 'enrich' &&
                            languageValues?.adminDashboard?.contentType?.enrich[actLanguage]
                          }
                          {row.contentType === 'icebreaker' &&
                            languageValues?.adminDashboard?.contentType?.icebreaker[actLanguage]
                          }
                        </TableCell>
                      </Hidden>
                      <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                        {row.contentName}
                      </TableCell>
                      <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                        {row.status === "ended" &&
                          <Box sx={{display:"flex", gap:"6px", height:"100%", whiteSpace:"nowrap"}}>
                            <img src={checkGreenRoundIcon} style={{width:"18px"}}/>
                            {row.isIcebreakerResult !== true &&
                              <Box>
                                {row.scoreGlobale}
                                <Hidden mdDown>
                                  <font>
                                  /100
                                  </font>
                                </Hidden>
                                <Hidden mdUp>
                                  <font style={{fontSize:"9px"}}>
                                  /100
                                  </font>
                                </Hidden>
                                {row.endedInRat === true && languageValues?.adminDashboard?.monitoringTable?.rattrapage[actLanguage]}
                              </Box>
                            }
                            {row.isIcebreakerResult === true &&
                              <Box>
                                <Hidden mdDown>
                                  {languageValues?.adminDashboard?.monitoringTable?.statusEnded[actLanguage]}
                                </Hidden>
                                <Hidden mdUp>
                                  <font style={{fontSize:"9px"}}>
                                    {languageValues?.adminDashboard?.monitoringTable?.statusEnded[actLanguage]}
                                  </font>
                                </Hidden>
                              </Box>
                            }
                          </Box>
                        }
                        {row.status === "inProgress" &&
                          <Box sx={{display:"flex", gap:"6px", height:"100%"}}>
                            <Box sx={{position:"relative"}}>
                              <CircularProgress variant="determinate" value={100} thickness={5.5} size="18px" sx={{color: '#E7E7E7'}} />
                              <CircularProgress
                                variant="determinate"
                                value={row.progress}
                                thickness={6}
                                size="18px"
                                sx={{
                                  color: "black",
                                  position: 'absolute',
                                  left: 0,
                                }}
                              />
                            </Box>
                            <Box>
                              <Hidden mdDown>
                                {languageValues?.adminDashboard?.monitoringTable?.statusProgress[actLanguage]}
                                {row.progress}%
                              </Hidden>
                              <Hidden mdUp>
                                {row.progress}%
                              </Hidden>
                            </Box>
                          </Box>
                        }
                        {row.status === "notStarted" &&
                          <Box sx={{display:"flex", gap:"6px", height:"100%"}}>
                            <Box sx={{position:"relative"}}>
                              <img src={sablierIcon} style={{height:"18px", marginLeft:"3px"}} />
                            </Box>
                            <Box>
                              <Hidden mdDown>
                                {languageValues?.adminDashboard?.monitoringTable?.statusNotStarted[actLanguage]}
                              </Hidden>
                              <Hidden mdUp>
                                {row.progress}%
                              </Hidden>
                            </Box>
                          </Box>
                        }
                      </TableCell>
                    </TableRow>
                  )
                })}
                </TableBody>
              </Table>
            </TableContainer>

            <Pagination
              sx={{
                display:"flex",
                justifyContent:"center",
                marginTop:"20px",
                userSelect:"none",
                '& .MuiPaginationItem-root' : {
                  color:"text.subTitle",
                },
                '& .MuiPaginationItem-root.MuiButtonBase-root' : {
                  background:"white",
                  border:"1px solid #E7E7E7",
                  color: "text.subTitle",
                  borderRadius:"0 !important",
                },
                '& .MuiPaginationItem-root.MuiButtonBase-root.Mui-selected' : {
                  background:"white",
                  border:"1px solid #E7E7E7",
                  color: "text.black",
                },
                '& .MuiPaginationItem-root.MuiButtonBase-root:hover' : {
                  background:"white",
                  color: "text.black",
                  border:"1px solid black",
                },
              }}
              siblingCount={0}
              boundaryCount={1}
              count={nbrPage}
              page={page}
              shape="rounded"
              onChange={(e, page) => {
                if (page) {
                  setPage(page)
                  if (popoverRef && popoverRef.current) {
                    popoverRef.current.scrollIntoView()
                  }
                }
              }}
            />

            <Box sx={{
              display:"flex",
              justifyContent:"center",
              marginTop:"15px",
              color:"text.subTitle",
              fontSize:'13px',
            }}>
              {((page-1) * 25) + 1}
              {'-'}
              {((page-1) * 25) + 25 > filteredData.length ? filteredData.length : ((page-1) * 25) + 25}
              {' sur '}
              {filteredData.length}
            </Box>


            <MyPopover
              isDrawerOpen={popoverFilters}
              anchorEl={popoverRef.current}
              handleClose={() => { setPopoverFilters(false) }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <ActionList
                glbData={glbData}
                filters={filters}
                setFilters={setFilters}
                icebreakerQuestions={actEcole?.icebreakerQuestions}
              />
            </MyPopover>

          </>
        }

      </Box>

    </>
  )
}


export default Suivi
